module.exports = __webpack_public_path__ + "static/media/TelaSaqueReaportePT.c1b8d033.png";